import { connect } from 'react-redux';

import FlagVariation from './FlagVariation';
import { selectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  flags: selectors.getFeatureFlagsState(state).flags,
});

export default connect(mapStateToProps, {})(FlagVariation);
